import { Skeleton } from "@/components/ui/skeleton";

interface MemoryCardSkeletonProps {
  variant?: "default" | "compact";
  showAvatar?: boolean;
}

export const MemoryCardSkeleton = ({ variant = "default", showAvatar = false }: MemoryCardSkeletonProps) => {
  if (variant === "compact") {
    return (
      <div className="p-3 rounded-lg border border-gray-100">
        {showAvatar && (
          <div className="flex items-center gap-2 mb-2">
            <Skeleton className="w-8 h-8 rounded-full" />
            <Skeleton className="h-4 w-24" />
          </div>
        )}
        <Skeleton className="h-4 w-full mb-2" />
        <Skeleton className="h-4 w-3/4 mb-2" />
        <div className="flex items-center justify-between">
          <Skeleton className="h-3 w-32" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>
    );
  }

  return (
    <div className="pb-4 rounded-lg p-2">
      {showAvatar && (
        <div className="flex items-center gap-3 mb-3">
          <Skeleton className="w-10 h-10 rounded-full" />
          <Skeleton className="h-5 w-32" />
        </div>
      )}
      <div className="flex items-start justify-between mb-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-4 w-16" />
      </div>
      <Skeleton className="h-4 w-full mb-1" />
      <Skeleton className="h-4 w-5/6 mb-2" />
      <Skeleton className="h-4 w-24" />
    </div>
  );
};
